import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[panelBody]',
  standalone: true
})
export class PanelBodyDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
